import Alert from './AlertMessage';

const alertTypes = {
    baseAlert: Alert
};

export default alertTypes;